import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";

const API_BASE = "https://api.mmwmachine.com/api";

const BlogList = () => {
  const [blogs, setBlogs] = useState([]);
  const [filteredBlogs, setFilteredBlogs] = useState([]);

  const [websites, setWebsites] = useState([]);
  const [selectedWebsite, setSelectedWebsite] = useState("");
  const [searchText, setSearchText] = useState("");

  // Fetch blogs + websites on load
  useEffect(() => {
    fetchBlogs();
    fetchWebsites();
  }, []);

  const fetchBlogs = () => {
    axios
      .get(`${API_BASE}/blogs`)
      .then((res) => {
        setBlogs(res.data);
        setFilteredBlogs(res.data);
      })
      .catch((err) => console.error(err));
  };

  const fetchWebsites = () => {
    axios
      .get(`${API_BASE}/websites/all`)
      .then((res) => setWebsites(res.data.websites))
      .catch((err) => console.error(err));
  };

  // Filter logic
  useEffect(() => {
    let data = blogs;

    // Filter by website
    if (selectedWebsite) {
      data = data.filter((b) => b.websiteId === selectedWebsite);
    }

    // Search by blog title
    if (searchText.trim() !== "") {
      data = data.filter((b) =>
        b.title.toLowerCase().includes(searchText.toLowerCase())
      );
    }

    setFilteredBlogs(data);
  }, [selectedWebsite, searchText, blogs]);

  return (
    <div className="container mt-4">
      <h2>Blogs</h2>

      {/* Filters */}
      <div className="row mt-3 mb-4">
        <div className="col-md-3">
          <label>Filter by Website</label>
          <select
            className="form-control"
            value={selectedWebsite}
            onChange={(e) => setSelectedWebsite(e.target.value)}
          >
            <option value="">All Websites</option>
            {websites.map((w) => (
              <option key={w._id} value={w._id}>
                {w.name}
              </option>
            ))}
          </select>
        </div>

        <div className="col-md-3">
          <label>Search Blog</label>
          <input
            className="form-control"
            placeholder="Search by blog title..."
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
          />
        </div>

        <div className="col-md-3 d-flex align-items-end">
          <button
            className="btn btn-secondary w-100"
            onClick={() => {
              setSelectedWebsite("");
              setSearchText("");
            }}
          >
            Reset Filters
          </button>
        </div>
      </div>

      {/* Blog Table */}
      <table className="table table-bordered">
        <thead>
          <tr>
            <th>Title</th>
            <th>Slug</th>
            <th>Website</th>
            <th>Created</th>
            <th>Actions</th>
          </tr>
        </thead>

        <tbody>
          {filteredBlogs.length === 0 ? (
            <tr>
              <td colSpan="5" className="text-center">
                No blogs found
              </td>
            </tr>
          ) : (
            filteredBlogs.map((blog) => (
              <tr key={blog._id}>
                <td>{blog.title}</td>
                <td>{blog.slug}</td>
                <td>
                  {
                    websites.find((w) => w._id === blog.websiteId)?.name ||
                    "Unknown"
                  }
                </td>
                <td>{new Date(blog.createdAt).toLocaleDateString()}</td>

                <td>
                  <Link
                    to={`/edit-blog/${blog._id}`}
                    className="btn btn-primary btn-sm"
                  >
                    Edit
                  </Link>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default BlogList;
